import { GetterTree } from "vuex";
import { ISecurityState } from "./state";
import { IAppointment, IAppointmentSecurityDay } from "@/models";

export const getters: GetterTree<ISecurityState, any> = {
    getSecurityDay: (state) => (): IAppointmentSecurityDay => {
        return state.securityDay;
    },

    getSelectedAppointment: (state) => (): IAppointment => {
        return state.selectedAppointment;
    },
};
